<template>
    <div>
        <el-dialog
            title="弃标"
            :visible.sync="visible">
            <div>
                <el-form>
                    <el-form-item label="弃标说明:" required>
                        <el-input type="textarea" rows="5" v-model="remarks"></el-input>
                    </el-form-item>
                    <el-form-item label="弃标文件:" required>
                        <div style="height: 25px;background-color: transparent"></div>
                        <page-upload @finishUpload="finishUpload" v-model="files" :attachmentType="206" edit-flag="true" not-many="true" style="margin-top: 15px">
                        </page-upload>
                    </el-form-item>
                </el-form>
                <el-button type="primary" size="mini" @click="giveUp">弃标</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "bidGiveUp",
    props:['wflowFormId','supplierId','dealId'],
    data(){
        return{
            visible:false,
            remarks:'',
            files:[]
        }
    },
    methods:{
        finishUpload(files){
            this.files = files.fileList
        },
        giveUp(){
            if (!this.remarks){
                this.$alert('请填写弃标说明',{
                    type:"warning"
                })
                return
            }
            if (!this.files || this.files.length === 0){
                this.$alert('请上传弃标文件',{
                    type:"warning"
                })
                return
            }
            let formParams = {
                bidBackSaveFlag : 2,
                wflowFormId: this.wflowFormId,
                supplierId: this.supplierId,
                dealId: this.dealId,
                remarks:this.remarks,
                techScoreTemplateList: [],
                wflowFormListFlag:0
            };
            formParams.outMapAttachmentVOs = {};
            formParams.outMapAttachmentVOs['206'] = this.files;
            let that = this;
            this.$root.postHttp('/v1/outerformflowHS/bidBack',formParams,function(res){
                that.$alert('已弃标', '提示', {
                    confirmButtonText: '确定',
                    type: 'success',
                    callback: action => {
                        that.visible = false
                        that.$router.push('../gateway/index')
                    }
                });
            },function(){
            })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/bid/components/bidGiveUp.vue